import axios, { AxiosResponse } from "axios";
import BaseService from "../base/BaseService";

export default class UserPlanService extends BaseService {
    getCoachingRemainingDays(): Promise<number> {
        return axios.get( `/UserPlan/GetCoachingRemainingDays`)
            .then(function (response: AxiosResponse<number, any>) {
                return response.data;
            });
    }
}